export const formatThousands = (value: number) => String(value).replaceAll(/\B(?=(\d{3})+(?!\d))/g, '.');
